import { toInteger } from 'lodash';
import { base64Kit } from '@/utils/base64-kit';
import { createCanvas, loadImageAsync } from '@/utils/file-kit';
import type { ILayerProps, IWatermarkLayerProps } from '@/version-types';
import { computeFullScreenWatermarkSize } from '../utils/watermark';

export const renderLayerContentToCanvas = async (layer: ILayerProps, scale = 1): Promise<HTMLCanvasElement> => {
    const { width, height } = layer;
    const { url, originUrl, isFullScreen, size } = layer.data as IWatermarkLayerProps;
    const localUrl = base64Kit.getLocalUrl(url || originUrl);
    const resultWidth = Math.max(1, toInteger(width * scale));
    const resultHeight = Math.max(1, toInteger(height * scale));

    if (!localUrl) {
        return createCanvas(resultWidth, resultHeight).canvas;
    }

    if (isFullScreen) {
        const image = await loadImageAsync(localUrl);
        const watermarkSize = computeFullScreenWatermarkSize(
            size,
            {
                width: image.width,
                height: image.height,
            },
            {
                width,
                height,
            },
        );
        const { canvas, ctx } = createCanvas(resultWidth, resultHeight);
        const { canvas: patternCanvas, ctx: patternCtx } = createCanvas(
            Math.max(1, toInteger(watermarkSize.width * scale)),
            Math.max(1, toInteger(watermarkSize.height * scale)),
        );

        patternCtx.drawImage(image, 0, 0, patternCanvas.width, patternCanvas.height);
        const pattern = ctx.createPattern(patternCanvas, 'repeat');
        if (pattern) {
            ctx.fillStyle = pattern;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }

        return canvas;
    }

    const image = await loadImageAsync(localUrl);
    const { canvas, ctx } = createCanvas(resultWidth, resultHeight);
    ctx.drawImage(image, 0, 0, resultWidth, resultHeight);
    return canvas;
};
